// extracted by mini-css-extract-plugin
module.exports = {"alreadyBtn":"InputText_alreadyBtn__2_7yc","inputContainer":"InputText_inputContainer__2DHO4","container":"InputText_container__ubG1P","title":"InputText_title__1oM8D"};